import React from 'react';
import { connect } from 'react-redux';
import { getSectionBackgroundData, getSectionBorderData, getSectionById } from 'zoomforth_codesbane_viewer/reducers/index.js';
import TabsSection from './tabs_section.jsx';

const mapStateToProps = (state, ownProps) => {  
  // Fetch section data for tabs that only store sectionId references
  const sectionWithResolvedTabs = {
    ...ownProps.section,
    tabs: (ownProps.section.tabs || []).map(tab => ({
      ...tab,
      content: tab.content && tab.content.sectionId ? {
        ...tab.content,
        section: getSectionById(state, tab.content.sectionId)
      } : tab.content
    }))
  };

  return { 
    section: sectionWithResolvedTabs,
    subpage: ownProps.subpage,
    innerBackgroundData: getSectionBackgroundData(state, ownProps.section, 'innerBackgroundData'),
    borderData: getSectionBorderData(state, ownProps.section)
  };
};

const TabsSectionContainer = ({ section, innerBackgroundData, borderData, ...props }) => {
  return (
    <TabsSection
      section={section}
      innerBackgroundData={innerBackgroundData}
      borderData={borderData}
      {...props}
    />
  );
};

export default connect(mapStateToProps)(TabsSectionContainer);
